import { AdminEventsTableRowActionsButtonProps } from './admin-events-table-row-actions-button-props';
import { AdminTableActionButton } from '../admin-table-action-button';
import { AdminTableActionButtonItem } from '../admin-table-action-button-item';
import React from 'react';
import { useAdminEventsTableController } from './use-admin-events-table-controller';

export const AdminEventsTableRowActionsButton: React.FunctionComponent<
  AdminEventsTableRowActionsButtonProps
> = props => {
  const { onDeleteClick, onEditClick } = useAdminEventsTableController({
    eventName: props.eventName,
    eventId: props.eventId,
  });
  return (
    <AdminTableActionButton>
      <AdminTableActionButtonItem onClick={onEditClick}>
        Edit Event
      </AdminTableActionButtonItem>
      <AdminTableActionButtonItem onClick={onDeleteClick} color="danger">
        Delete Event
      </AdminTableActionButtonItem>
    </AdminTableActionButton>
  );
};
